export { default } from './ContentResolver';
